// extracted by mini-css-extract-plugin
module.exports = {"cont":"BizGoodsDataViewImage_cont__2nFQV","index":"BizGoodsDataViewImage_index__rac3r","content":"BizGoodsDataViewImage_content__31Uop"};